import { crud } from "./crud";
import { httpPost } from "../services/http";

const currentLang = (document.querySelector('#language') || {}).value;

export const language = (state = [], action) => crud('language', state, action, () => state);

export const getLanguages = () => {
	return (dispatch, state) => {
		if (state().language.length === 0)
			httpPost('language/getAll', {}).then(data => {
				const find = data.data.find(el => el.code === currentLang);
				if (find) {
					dispatch({
						type: 'LANG',
						data: find
					});
				} else {
					dispatch({
						type: 'LANG',
						data: data.data[0] ? data.data[0]._id : ''
					});
				}

				dispatch(data)

			});
	}
};